export default __webpack_public_path__ + "media/images/instagram-4373c8df39d3311e16a2fcfed6e7a939.svg";